<svelte:options
  customElement={{
    tag: "oc-energy-label-v1",
    /*                                            */
    extend: window.__components.extend(),
    props: {
      color: { type: "String" },
      size: { type: "String" },
      variant: { type: "String" },
      version: { type: "String" },
    },
  }}
/>

<script lang="ts">
  import type { Props } from "./EnergyLabelV1.types.js";

  const EEK_PREFIX = "pl_eek2024";
  const EEK_ASSETS_URL_PREFIX = "/static-proxy/assets-static/icons/";

  export let size: Props["size"] = "100";
  export let variant: Props["variant"] = "A";
  export let color: Props["color"] = "#33a357";
  export let version: Props["version"] = "default";

  function svgUrl(svgId: string): string {
    return `${EEK_ASSETS_URL_PREFIX}${svgId}.svg`;
  }

  function svgIdentifier(label: string, labelSize: string, labelVersion: string): string {
    const plusCount = label.split("+").length - 1;
    if (plusCount > 0) {
      return `${EEK_PREFIX}_${labelVersion}_${label.toLowerCase()[0]}${plusCount}_${labelSize}`;
    }
    return `${EEK_PREFIX}_${labelVersion}_${label.toLowerCase()}_${labelSize}`;
  }

  $: svgId = svgIdentifier(variant!, size!, version!);
  $: url = svgUrl(svgId);
  $: labelChar = variant;
</script>

<div
  class="energy-label energy-label--size-{size}"
  style="--energy-label-background-color: {color}"
>
  <svg role="img">
    <title>Energieverbrauchskennzeichnung {labelChar}</title>
    <use href="{url}#{svgId}" />
  </svg>
</div>

<style lang="scss" global>
  @use "@otto-ec/design-tokens/tokens";

  :host {
    display: inline-block;
  }

  .energy-label {
    height: 100%;
    width: 100%;

    > svg {
      height: 100%;
      width: 100%;
    }

    &--size-100 {
      height: 20px;
      width: 36px;
    }

    &--size-200 {
      height: 36px;
      width: 64px;
    }

    use {
      color: var(--energy-label-background-color, gray);
    }
  }
</style>
